import {
  applyImagePolicy,
  hasThumborKey,
  NO_IMAGE_URL
} from '@/utils/thumborUtils'
import {
  applyImagePolicy as applyCache2Policy,
  ImageMode
} from '@/utils/imageExtension'

export type ProductImageSize = { width: number; height: number }

export type ProductImageUrls = { primary: string; fallback: string }

const THUMBOR_PRODUCT_PERCENT = 50

export const isThumborEnabledForProduct = (
  productId: string | number,
  percent = THUMBOR_PRODUCT_PERCENT
): boolean => !!productId && Number(productId) % 100 < percent

export const getProductImageUrls = (
  url: string,
  size: ProductImageSize,
  {
    fallbackSize = size,
    fill = true,
    useThumbor = true
  }: {
    fallbackSize?: ProductImageSize
    fill?: boolean
    useThumbor?: boolean
  } = {}
): ProductImageUrls => {
  if (!url) {
    return { primary: NO_IMAGE_URL, fallback: NO_IMAGE_URL }
  }
  const fallback = applyCache2Policy(url, {
    size: fallbackSize,
    mode: ImageMode.Local
  })
  const primary =
    useThumbor && hasThumborKey()
      ? applyImagePolicy(url, {
          size,
          useFitIn: true,
          fill: fill ? 'white' : undefined
        })
      : fallback
  return { primary, fallback }
}
